var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector42X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9744 18.2856C20.9744 18.6894 20.6471 19.0168 20.2432 19.0168H0.731252C0.327394 19.0168 0 18.6894 0 18.2856V17.6555C0 17.2516 0.327392 16.9243 0.73125 16.9243H1.04872V9.63276C1.04872 4.41393 5.27507 0.183838 10.4872 0.183838C15.6994 0.183838 19.9257 4.41393 19.9257 9.63276V16.9243H20.2432C20.6471 16.9243 20.9744 17.2516 20.9744 17.6555V18.2856ZM3.14617 16.9243H17.8283V9.63276C17.8283 5.57007 14.5416 2.27639 10.4872 2.27639C6.43286 2.27639 3.14617 5.57007 3.14617 9.63276V16.9243ZM7.96719 20.7848C7.85551 20.3967 8.19281 20.0631 8.59667 20.0631H12.3778C12.7816 20.0631 13.1189 20.3967 13.0072 20.7848C12.8857 21.2073 12.6582 21.5963 12.3411 21.9127C11.8494 22.4032 11.1826 22.6788 10.4872 22.6788C9.79188 22.6788 9.12501 22.4032 8.63333 21.9127C8.31624 21.5963 8.08877 21.2073 7.96719 20.7848Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector42X);
export default __webpack_public_path__ + "static/media/vector-4@2x.fd8309bbd8d052e4390cc99dfa607493.svg";
export { ForwardRef as ReactComponent };